<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-form
      class="mx-auto small-page-width"
      @submit.prevent="save()"
    >
      <v-card>
        <v-card-title>
          {{ $t('sign_up') }}
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-text-field
            v-model="item.data.name"
            :error-messages="errorsByField.name"
            :label="$t('username')"
          />
          <v-text-field
            v-model="item.data.email"
            :error-messages="errorsByField.email"
            :label="$t('email')"
          />
          <v-text-field
            v-model="item.data.password"
            :error-messages="errorsByField.password"
            :label="$t('password')"
            type="password"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            color="secondary"
            :disabled="isLoading"
            text
            type="submit"
          >
            {{ $t('create_account') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { User } from '@serversgg/sdk-js'

import errorHandlerMixin from '@/mixins/errorHandlerMixin'

export default {
  name: 'UserCreateView',

  mixins: [
    errorHandlerMixin,
  ],

  data () {
    return {
      isLoading: false,
      item: new User(),
    }
  },

  metaInfo () {
    return {
      title: this.$t('sign_up'),
    }
  },

  methods: {
    async save () {
      if (this.isLoading) {
        return
      }

      try {
        const password = this.item.data.password

        await this.item
          .request()
          .save()

        await this.$store.dispatch('auth/attempt', {
          email: this.item.data.email,
          password,
        })

        this.$notify('info', this.$t('sign_in_success'))

        await this.$router.push({
          name: 'server.index',
        })
      } catch (e) {
        await this.handleException(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
